import {useMutation, useQueryClient} from '@tanstack/react-query';

import {RQ_UPDATE_Admin_PROFILE_API, RQ_UPDATE_User_PROFILE_API} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQUpdateAdminProfileAPI = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_update_admin_profile'], 

    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_Admin_PROFILE_API.url.replace('<%= id %>', id);
      return rqCreateRequest(
        {...RQ_UPDATE_Admin_PROFILE_API, url},
        formData,
        token,
        null,
      );
    },

    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['rq_get_admin_profile']});
    },

    ...options,
  });
};

export const RQUpdateUserProfileAPI = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_update_user_profile'], 

    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_User_PROFILE_API.url.replace('<%= id %>', id);
      return rqCreateRequest(
        {...RQ_UPDATE_User_PROFILE_API, url},
        formData,
        token,
        null,
      );
    },

    onSuccess: updatedProfile => {
      queryClient.setQueryData(
        ['rq_get_user_profile'],
        updatedProfile,
      );
    },
    ...options,
  });
};
